import React, { useEffect, useRef, useState } from 'react'
import compose from 'recompose/compose'
import _ from 'lodash'
import moment from 'moment-timezone'
import { withI18n } from '../../hocs'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import * as S from './styled'
import { RegularButtonOutline, InputField, DateInput, TimeInput, InputEditor } from '../../atoms'
import { AlertDialog, SimpleDialog } from '../../molecules'
import ActionDialog from '../action-dialog'
import { useLocation } from "react-router";
import useDefaultMessages from "../../../api/queries/useDefaultMessages";
import { useAppContext } from "../../../context/appContext";
import { getCurrentSectionKey, INTEGRATIONS, MODULES, SECTION_KEYS } from "../../../config/constants";
import Switch from '@material-ui/core/Switch';
import Divider from "@material-ui/core/Divider";
import {Box} from "@material-ui/core";
import * as api from '../../../api'
import { Paperclip } from 'lucide-react'
import { tokens } from '../../../assets/tokens'
import { useTheme } from '@material-ui/styles'

const ModalAnnouncementQuery = ({
  open,
  handleClose,
  i18n,
  onSubmit,
  self,
  sms,
  rowsSelected = 0,
  data = null,
  suggestChangeStatusModal,
  isEditFromTab,
 }) => {

  const theme = useTheme()
  const { module, clearContextIfNeeded } = useAppContext();
  const currentLocation = useLocation();

  const [openPopup, setOpenPopup] = React.useState(false)
  const [isSwitchActive, setIsSwitchActive] = React.useState(false)
  const [eventName, setEventName] = React.useState('')
  const [optionalAttendees, setOptionalAttendees] = React.useState('')
  const [meetingData, setMeetingData] = React.useState(null);
  const [location, setLocation] = React.useState('')
  const [interviewer, setInterviewer] = React.useState('');
  const [message, setMessage] = React.useState('')

  const [date, setDate] = React.useState(() => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 1); // Sumar un día
    return currentDate;
  });

  const [startTime, setStartTime] = React.useState(moment().add(1, 'days').set({ hour: 8, minute: 0 }).format('HH:mm'));
  const [endTime, setEndTime] = React.useState(moment().add(1, 'days').set({ hour: 9, minute: 0 }).format('HH:mm'));
  const [isConfirmationModalOnCitations, setIsConfirmationModalOnCitations] = useState(false)
  const [external_id, setExternalId] = useState(null)
  const [citation_id, setCitationId] = useState(null);
  const [attachmentUploading, setAttachmentUploading] = useState(false)
  const [attachmentError, setAttachmentError] = useState('')
  const attachmentInputRef = useRef(null)

  const { data: defaultMessages } = useDefaultMessages(module);

  const userTimeZone = moment.tz.guess();
  // const userTimeZone = 'Europe/London';
  const ATTACHMENT_PREFIX = i18n.modalAnnouncement?.attachment
  const ATTACHMENTS_PREFIX = i18n.modalAnnouncement?.attachments

  const normalizeEditorText = rawValue => {
    if (!rawValue) return ''
    if (typeof rawValue !== 'string') return ''

    const hasHtml = /<[^>]+>/.test(rawValue)
    if (!hasHtml) return rawValue

    return rawValue
      .replace(/<p><br><\/p>/gi, '\n')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<p>/gi, '')
      .replace(/<[^>]+>/g, '')
      .replace(/&nbsp;/gi, ' ')
      .trim()
  }

  const extractAttachmentFromMessage = rawMessage => {
    const normalizedMessage = normalizeEditorText(rawMessage)

    if (!normalizedMessage || typeof normalizedMessage !== 'string') {
      return { cleanMessage: '', attachmentFromMessage: [] }
    }

    const extractUrls = text => {
      const matches = (text || '').match(/https?:\/\/\S+/gi) || []
      return matches.map(url => url.replace(/[),.;]+$/g, ''))
    }

    const escapeRegex = value => (value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    const attachmentPrefixRegex = new RegExp(`^${escapeRegex(ATTACHMENT_PREFIX || 'Adjunto:')}\\s*`, 'i')
    const attachmentsPrefixRegex = new RegExp(`^${escapeRegex(ATTACHMENTS_PREFIX || 'Adjuntos:')}\\s*`, 'i')

    const lines = normalizedMessage.replace(/\r\n/g, '\n').split('\n')
    const cleanLines = []
    const attachmentFromMessage = []

    let insideAttachmentBlock = false

    lines.forEach(rawLine => {
      const line = rawLine || ''
      const trimmedLine = line.trim()

      const isAttachmentTitle = attachmentPrefixRegex.test(trimmedLine) || attachmentsPrefixRegex.test(trimmedLine)

      if (isAttachmentTitle) {
        const inlineUrls = extractUrls(trimmedLine)
        if (!_.isEmpty(inlineUrls)) {
          attachmentFromMessage.push(...inlineUrls)
        }
        insideAttachmentBlock = true
        return
      }

      const isBulletUrl = /^-\s*https?:\/\//i.test(trimmedLine)
      const isSingleUrl = /^https?:\/\//i.test(trimmedLine)

      if (insideAttachmentBlock && (isBulletUrl || isSingleUrl)) {
        attachmentFromMessage.push(...extractUrls(trimmedLine))
        return
      }

      if (insideAttachmentBlock && trimmedLine === '') {
        return
      }

      if (insideAttachmentBlock && !(isBulletUrl || isSingleUrl)) {
        insideAttachmentBlock = false
      }

      cleanLines.push(line)
    })

    const cleanMessage = cleanLines.join('\n').replace(/\n{3,}/g, '\n\n').trim()

    return {
      cleanMessage,
      attachmentFromMessage: _.uniq(attachmentFromMessage),
    }
  }

  const buildMessageWithAttachment = (baseMessage, attachments = []) => {
    const { cleanMessage } = extractAttachmentFromMessage(normalizeEditorText(baseMessage))
    const validAttachments = _.uniq((attachments || []).filter(url => /^https?:\/\//i.test(url)))

    const escapeHtml = value => (value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')

    const toParagraphHtml = text => {
      if (!text) return ''

      return text
        .replace(/\r\n/g, '\n')
        .split('\n')
        .map(line => line.trim() ? `<p>${escapeHtml(line)}</p>` : '<p><br></p>')
        .join('')
    }

    if (_.isEmpty(validAttachments)) {
      return toParagraphHtml(cleanMessage)
    }

    const attachmentTitle = validAttachments.length === 1 ? ATTACHMENT_PREFIX : ATTACHMENTS_PREFIX
    const attachmentBlock = `<p>${escapeHtml(attachmentTitle)}</p>${validAttachments
      .map(url => `<p>- ${escapeHtml(url)}</p>`)
      .join('')}`

    const cleanMessageHtml = toParagraphHtml(cleanMessage)

    return cleanMessageHtml ? `${cleanMessageHtml}<p><br></p>${attachmentBlock}` : attachmentBlock
  }

  const appendAttachmentsToMessage = (baseMessage, newAttachments = []) => {
    const { attachmentFromMessage } = extractAttachmentFromMessage(baseMessage)
    const mergedAttachments = _.uniq([...(attachmentFromMessage || []), ...(newAttachments || [])])
    return buildMessageWithAttachment(baseMessage, mergedAttachments)
  }

  useEffect(() => {
    clearContextIfNeeded(MODULES.currentModule());
  }, [module, currentLocation.pathname]);

  useEffect(() => {
    if (data && !_.isEmpty(data)) {
      if (data.hasOwnProperty('citationDate')) {
        let tmpDate = null;

        let timezonedInitDate = null;
        let timezonedEndDate = null;
        let startTime = null;
        let endTime = null;

        if(data.citationDate && data.citationDate.date) {
          tmpDate = moment.tz(data.citationDate.date, data.citationDate.timezone);
          timezonedInitDate = tmpDate.clone().tz(userTimeZone);
          startTime = timezonedInitDate.format('HH:mm');
        }
        if(data.citationEndDate && data.citationEndDate.date) {
          tmpDate = moment.tz(data.citationEndDate.date, data.citationEndDate.timezone);
          timezonedEndDate = tmpDate.clone().tz(userTimeZone);
          endTime = timezonedEndDate.format('HH:mm')
        }

        setDate(timezonedInitDate ? timezonedInitDate.toDate() : (new Date()));
        setStartTime(startTime);
        setEndTime(endTime);
      }

      setEventName(data.hasOwnProperty('eventName') ? data.eventName : '');
      setOptionalAttendees(getCurrentSectionKey() !== SECTION_KEYS.INBOX && data.hasOwnProperty('optionalAttendees') ? data.optionalAttendees : '');
      setLocation(data.hasOwnProperty('location') ? data.location : '');
      setInterviewer(data.hasOwnProperty('interviewer') ? data.interviewer : '');
      const originalMessage = data.hasOwnProperty('message') ? data.message : '';
      const { cleanMessage, attachmentFromMessage } = extractAttachmentFromMessage(originalMessage)
      setMessage(buildMessageWithAttachment(cleanMessage, attachmentFromMessage));
      setIsSwitchActive(data.hasOwnProperty('external_id') &&
        data.hasOwnProperty('link_meeting') &&
        !_.isEmpty(data.link_meeting));
      setExternalId((data.hasOwnProperty('external_id') && data.external_id !== '') ? data.external_id : null);
      let auxMeetingData = [];
      auxMeetingData['attendees'] = data.hasOwnProperty('attendees') ? data.attendees : [];
      auxMeetingData['organizer'] = data.hasOwnProperty('organizer') ? data.organizer : [];
      auxMeetingData['link_meeting'] = data.hasOwnProperty('link_meeting') ? data.link_meeting : '';
      setMeetingData(auxMeetingData);
      setCitationId(data.hasOwnProperty('id') ? data.id : null);
    }

  }, [data]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleAttachmentChange = async e => {
    const inputElement = e?.target || null
    const selectedFiles = _.get(e, 'target.files', [])

    if (!selectedFiles || selectedFiles.length === 0) {
      return
    }

    setAttachmentError('')
    setAttachmentUploading(true)

    try {
      const uploadResponses = await Promise.all(Array.from(selectedFiles).map(file => api.uploadFile(file)))
      const uploadedUrls = uploadResponses
        .map(response => _.get(response, 'data.upload', ''))
        .filter(url => !!url)

      if (_.isEmpty(uploadedUrls)) {
        setAttachmentError(i18n.modalAnnouncement?.attachmentUploadError)
      } else {
        setMessage(prevMessage => appendAttachmentsToMessage(prevMessage, uploadedUrls))
      }
    } catch (error) {
      setAttachmentError(i18n.modalAnnouncement?.attachmentUploadError)
    } finally {
      setAttachmentUploading(false)
      if (inputElement) {
        inputElement.value = ''
      } else if (attachmentInputRef.current) {
        attachmentInputRef.current.value = ''
      }
    }
  }

  const handleOpenAttachmentDialog = () => {
    if (attachmentInputRef.current && !attachmentUploading) {
      attachmentInputRef.current.click()
    }
  }

  function handleClickOpenPopup() {
    setOpenPopup(true)
  }

  const handleClosePopup = value => {
    setOpenPopup(false)

    if (value) {
      const eventName = value.event_name || ''
      const optionalAttendees = value.optionalAttendees || ''
      const interviewer = value.interviewer || ''
      const subject = value.subject || ''
      const location = value.location || ''
      const body = value.body || ''
      const { attachmentFromMessage } = extractAttachmentFromMessage(message)

      setEventName(eventName ? eventName : subject)
      setOptionalAttendees(optionalAttendees)
      setInterviewer(interviewer)
      setLocation(location)
      setMessage(buildMessageWithAttachment(normalizeEditorText(body), attachmentFromMessage))
    }
  }

  const clear = () => {
    setEventName('')
    setOptionalAttendees('')
    setLocation('')
    setInterviewer('')
    setMessage('')
    setDate(new Date())
    setStartTime(moment().format('HH:mm'))
    setEndTime(moment().format('HH:mm'))
    setIsSwitchActive(false)
    setExternalId(null)
    setCitationId(null)
    setAttachmentUploading(false)
    setAttachmentError('')
  }

  const handleSubmit = (e, send = false) => {
    e && e.preventDefault();
    if (send) {
      // La confirmación devuelve la petición: los modales se cierran cuando ha ido bien
      return submitAction().then(() => {
        handleClose();

        if(suggestChangeStatusModal)  {
          suggestChangeStatusModal.setIsOpenModalSuggestChangeStatus(true);
        }
      });
    } else {
      setIsConfirmationModalOnCitations(true);
    }
  }

  const submitAction = () => {
    const citation_date = new moment(`${moment(date).format('YYYY/DD/MM')} ${startTime}`, 'YYYY/DD/MM HH:mm').format('YYYY-MM-DD HH:mm:ss');
    const citation_end_date = new moment(`${moment(date).format('YYYY/DD/MM')} ${endTime}`, 'YYYY/DD/MM HH:mm').format('YYYY-MM-DD HH:mm:ss');
    const sms_notification = sms;
    const { attachmentFromMessage } = extractAttachmentFromMessage(message)
    const messageWithAttachment = buildMessageWithAttachment(message, attachmentFromMessage)

    return Promise.resolve(onSubmit({
      event_name: eventName,
      optional_attendees: optionalAttendees,
      location,
      citation_date,
      citation_end_date,
      online_meeting: isSwitchActive,
      interviewer,
      sms_notification,
      message: messageWithAttachment,
      external_id,
      citation_id,
    })).then(() => {
      setIsConfirmationModalOnCitations(false);
      clear();
    })
  }

  const toggleSwitch = () => setIsSwitchActive(!isSwitchActive);

  const validateDates = () => {
    const startTimeMoment = moment(startTime, 'HH:mm');
    const endTimeMoment = moment(endTime, 'HH:mm');

    return !startTimeMoment.isAfter(endTimeMoment);

  }

  const getCurrentIntegration = () => {
    if (self && INTEGRATIONS) {
      let currentIntegration = _.find(INTEGRATIONS, { event_type: self.event_type })
      return currentIntegration ? currentIntegration : null;
    }
    return null
  }
  return (
    <>
      <ActionDialog
        open={open}
        title={isEditFromTab ? i18n.modalAnnouncement.editQuoteCall : i18n.modalAnnouncement.quoteCall}
        onClose={handleClose}
        onConfirm={handleSubmit}
        cancelLabel={i18n.dialog.decline}
        confirmLabel={isEditFromTab ? i18n.modalAnnouncement.updateCitation : i18n.modalAnnouncement.sendCitation}
        confirmDisabled={!validateDates()}
        disableBackdropClose
      >
        <S.Body>
          {getCurrentIntegration() &&
            <div>
              <S.Label>{i18n.modalAnnouncement.new_event}</S.Label>
              <InputField
                fontSize="small"
                placeholder={i18n.modalAnnouncement.new_event}
                name="event_name"
                value={eventName}
                handleOnChange={value => {
                  return setEventName(value);
                }}
              />
            </div>
          }

          <div>
            <S.Label>{i18n.modalAnnouncement.citationDate}</S.Label>
            <div className="citation-datetime">
              <div className="citation-date">
                <DateInput fontSize="small" name="date" onChange={e => setDate(e)} value={date} />
              </div>
              <div className="time-range">
                <TimeInput
                  fontSize="small"
                  name="start_time"
                  onChange={setStartTime}
                  value={startTime}
                />
                <span>{i18n.modalAnnouncement.to_time}</span>
                <TimeInput
                  fontSize="small"
                  name="end_time"
                  onChange={setEndTime}
                  value={endTime}
                  isTo={true}
                />
              </div>
            </div>
          </div>
          {getCurrentIntegration() &&
            <div>
              <S.Label>{i18n.modalAnnouncement.online_meeting}</S.Label>
              <div className="online-meeting">
                <img src={require(`../../../assets/images/${getCurrentIntegration().logo}`).default} height={20} alt={getCurrentIntegration().event_type} />
                <Switch
                  checked={isSwitchActive}
                  onClick={() => { toggleSwitch() }}
                  name={"online_meeting"}
                  value="isSwitchActive"
                  color="primary"
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
              </div>
            </div>}
          {!isSwitchActive &&
            <div>
              <S.Label>{i18n.modalAnnouncement.location}</S.Label>
              <InputField
                fontSize="small"
                placeholder={i18n.modalAnnouncement.writeLocation}
                name="location"
                value={location}
                handleOnChange={value => setLocation(value)}
              />
            </div>}

          {!getCurrentIntegration() &&
            <div>
              <S.Label>{i18n.modalAnnouncement.interviewer}</S.Label>
              <InputField
                fontSize="small"
                placeholder={i18n.modalAnnouncement.writeInterviewer}
                name="interviewer"
                value={interviewer}
                handleOnChange={value => setInterviewer(value)}
              />
            </div>}

          <div>
            <S.Label>{i18n.modalAnnouncement.notes}</S.Label>
            <InputEditor
              fontSize="small"
              placeholder={getCurrentIntegration() ? i18n.modalAnnouncement.writeDetailsIntegration : i18n.modalAnnouncement.writeDetails}
              name="message"
              value={message}
              onChange={value => setMessage(value)}
            />
          </div>

          <div>
            <input
              id="citation-attachment-input"
              ref={attachmentInputRef}
              type="file"
              multiple
              onChange={handleAttachmentChange}
              style={{ display: 'none' }}
            />
            <RegularButtonOutline
              type="button"
              onClick={handleOpenAttachmentDialog}
              title={<S.ButtonContent><Paperclip size={16} />{attachmentUploading ? i18n.modalAnnouncement?.uploadingAttachment : i18n.modalAnnouncement?.attachFile}</S.ButtonContent>}
              disabled={attachmentUploading}
            />

            {attachmentError && <S.Error>{attachmentError}</S.Error>}
          </div>

          {getCurrentIntegration() &&
            <div>
              <S.Label>{i18n.modalAnnouncement.invite_people}</S.Label>
              <InputField
                placeholder={i18n.modalAnnouncement.invite_people_placeholder}
                name="optionalAttendees"
                value={optionalAttendees}
                handleOnChange={value => setOptionalAttendees(value)}
              />
            </div>
          }


          {/* Meeting Attendees */}
          {meetingData && external_id &&
            <div>
              <S.Label>{i18n.modalAnnouncement.attendees}</S.Label>
              <div>
                  {meetingData.attendees && meetingData.attendees.filter(at => at.type === 'required').map((attendee, index) => {
                    let color;
                    let status;
                    switch (attendee.status.response) {
                      case 'accepted':
                        color = tokens.color.success.main;
                        status = i18n.modalAnnouncement.accepted;
                        status = i18n.modalAnnouncement.accepted;
                        break;
                      case 'declined':
                      case 'rejected':
                        color = tokens.color.error.main;
                        status = i18n.modalAnnouncement[attendee.status.response];
                        break;
                      case 'tentative':
                        color = tokens.color.warning.main;
                        status = i18n.modalAnnouncement.tentative;
                        break;
                      case 'replan':
                        color = tokens.color.warning.main;
                        status = i18n.citationStatus.replan;
                        break;
                      default:
                        color = tokens.color.text.tertiary;
                        status = i18n.modalAnnouncement.none;
                    }
                    return (
                      <Grid container key={index}>
                        <Grid item xs={12} sm={6}>
                          <p style={{ fontSize: '14px' }} title={attendee.emailAddress.address}>
                            <a href={attendee.profile_link ? attendee.profile_link : '#'}
                               target="_blank"
                               rel="noopener noreferrer"
                               className='attendee-link'>{attendee.name}</a>
                          </p>
                        </Grid>
                        <Grid item xs={12} sm={6} display='flex' justifyContent='space-between'>
                          {meetingData.organizer.emailAddress && meetingData.organizer.emailAddress.address === attendee.emailAddress.address ? (
                            <strong style={{ color: theme.primary, fontSize: '14px', marginLeft: '5px' }}>{i18n.modalAnnouncement.organizer}</strong>) : (
                            <Box display='flex' justifyContent='space-between'>
                              <strong style={{ color: color, fontSize: '14px', marginLeft: '5px' }}>{status}</strong>
                              {['replan', 'rejected'].includes(attendee?.status?.response) &&
                                (attendee?.status?.not_interested ||
                                  attendee?.status?.availability) && (
                                  <strong style={{fontSize: '12px', marginLeft: '5px'}}>
                                    {attendee?.status?.not_interested
                                      ? attendee.status.not_interested
                                      : attendee?.status?.availability
                                        ? `${attendee.status.availability} - ${attendee.status.reason}`
                                        : ''}
                                  </strong>)
                              }
                            </Box>)
                          }
                        </Grid>
                      </Grid>
                    )
                  })}
                  <Divider className='boxInfoHeaderDivider' />
                  <p style={{ fontSize: '12px', marginTop: '12px', color: tokens.color.text.tertiary }}>{i18n.modalAnnouncement.optionals}:</p>
                  {meetingData.attendees && meetingData.attendees.filter(at => at.type === 'optional').map((attendee, index) => {
                    let color;
                    let status;
                    switch (attendee.status.response) {
                      case 'accepted':
                        color = tokens.color.success.main;
                        status = i18n.modalAnnouncement.accepted;
                        status = i18n.modalAnnouncement.accepted;
                        break;
                      case 'declined':
                      case 'rejected':
                        color = tokens.color.error.main;
                        status = i18n.modalAnnouncement[attendee.status.response];
                        break;
                      case 'tentative':
                        color = tokens.color.warning.main;
                        status = i18n.modalAnnouncement.tentative;
                        break;
                      case 'replan':
                        color = tokens.color.warning.main;
                        status = i18n.citationStatus.replan;
                        break;
                      default:
                        color = tokens.color.text.tertiary;
                        status = i18n.modalAnnouncement.none;
                    }
                    return (
                      <Grid container key={index}>
                        <Grid item xs={12} sm={6}>
                          <p style={{ fontSize: '14px' }}>{attendee.emailAddress.address}</p>
                        </Grid>
                        <Grid item xs={12} sm={6} display='flex' justifyContent='space-between'>
                          {meetingData.organizer.emailAddress && attendee.emailAddress &&
                            meetingData.organizer.emailAddress.address === attendee.emailAddress.address ? (
                            <strong style={{ color: theme.primary, fontSize: '14px', marginLeft: '5px' }}>{i18n.modalAnnouncement.organizer}</strong>
                          ) : (
                            <Box display='flex' justifyContent='space-between'>
                              <strong style={{ color: color, fontSize: '14px', marginLeft: '5px' }}>{status}</strong>
                              {['replan', 'rejected'].includes(attendee?.status?.response) &&
                                (attendee?.status?.not_interested ||
                                  attendee?.status?.availability) && (
                                  <strong style={{fontSize: '12px', marginLeft: '5px'}}>
                                    {attendee?.status?.not_interested
                                      ? attendee.status.not_interested
                                      : attendee?.status?.availability
                                        ? `${attendee.status.availability} - ${attendee.status.reason}`
                                        : ''}
                                  </strong>)
                              }
                            </Box>
                          )
                          }
                        </Grid>
                      </Grid>
                    )
                  })}

              </div>
            </div>
          }

          <S.Link type="button" onClick={handleClickOpenPopup}>{i18n.modalAnnouncement.defaultMessages}</S.Link>
        </S.Body>
        <SimpleDialog defaultMessages={defaultMessages} open={openPopup} onClose={handleClosePopup} />
      </ActionDialog>
      <AlertDialog
        open={isConfirmationModalOnCitations}
        onClose={() => setIsConfirmationModalOnCitations(false)}
        onSuccess={(e) => handleSubmit(e, true)}
        title={i18n.process.deleteModalTitle}
        text={rowsSelected && rowsSelected > 1 ? i18n.modalAnnouncement.confirmation.description_create_group.replaceAll('{num}', rowsSelected)
          : i18n.modalAnnouncement.confirmation.description_create_individual
        }
      />
    </>
  )
}

ModalAnnouncementQuery.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired
}

const enharce = compose(withI18n)

export default enharce(ModalAnnouncementQuery)
